// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.content[data-v-aa482a8a]{\n  opacity:0\n}\n.content.index[data-v-aa482a8a]{\n  height:150vh\n}\n.content.index .text[data-v-aa482a8a]{\n  pointer-events:none;\n  position:-webkit-sticky;\n  position:sticky;\n  top:10rem;\n  align-self:flex-start\n}\n.content[data-v-aa482a8a]  .char,.content[data-v-aa482a8a]  .word{\n  display:inline-block\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
